// extracted by mini-css-extract-plugin
module.exports = {"particle":"particle-module--particle--28Wpp"};